import { useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';
import { useApiMutation } from '../../../shared/useApi.js';

export function useAdjustStock() {
  const qc = useQueryClient();
  return useApiMutation({
    mutationFn: (body) => api.post('/purchases/movements/adjust', body).then((r) => r.data),
    successMessage: 'تم تسجيل التسوية',
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['inventory'] });
      qc.invalidateQueries({ queryKey: ['catalog', 'products'] });
      qc.invalidateQueries({ queryKey: ['reports'] });
    }
  });
}
